import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {InventoryCurrentBalanceContainerModel} from '../../../../../../models/aggregates/erp/inventory';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InventoryCurrentBalanceService extends BaseApiTemplateService<InventoryCurrentBalanceContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + 'inv-stock/current';
    this.httpClient = http;
  }

}


